import { getFeatureFlagValue } from '@citrite/feature-flags';
import { AccountPreferences, UserRole } from '@citrite/sf-api';
import { Account, EntitlementsContextApi, User } from '@sharefiledev/sharefile-appshell';
import { Entitlements } from '../constants';
import { DocumentTemplate } from '../data/interfaces/DocumentTemplate';
import accountsWithKBA from '../data/kbaAccounts';
import { FeatureFlag } from '../FeatureFlags';
import { getSecondLevelDomain } from './stringUtil';

const canCreateTemplate = (account: Account) => {
	return documentGenerationEnabledForAccount(account.Preferences);
};

const documentGenerationEnabledForAccount = (accountPrefs: AccountPreferences) => {
	return accountPrefs.EnableIntegrations;
};

export const isCreateTemplateActionAvailable = (
	account: Account,
	entitlements: EntitlementsContextApi
) => {
	return (
		canCreateTemplate(account) &&
		entitlements.getEntitlementStatus(Entitlements.CreateDocumentTemplate)
	);
};

export const isAccountKBAEnabled = (account: Account) => {
	return accountsWithKBA.includes(account?.Services?.RightSignature?.AddOnCode);
};

const isAccountVDR = (account: Account) => {
	return (
		account.PlanName.includes('VDR') &&
		getSecondLevelDomain(account.Preferences.FtpServerName) === 'securevdr'
	);
};

// Currently Thumbnails are not supported for VDR accounts.
export const isThumbnailSupported = (account: Account) => {
	return !isAccountVDR(account);
};

export const canSendForSignature = (user: User) => {
	return !!user?.Roles?.includes(UserRole.CanSendDocumentsForSignature);
};

export const isSendForSignatureActionAvailable = (user, entitlements) => {
	return (
		canSendForSignature(user) &&
		entitlements.getEntitlementStatus(Entitlements.SendForSignature)
	);
};

const canEditTemplate = (documentTemplate: DocumentTemplate) => {
	return !!documentTemplate?.permissions?.canModify;
};

export const isEditTemplateActionAvailable = (
	documentTemplate: DocumentTemplate,
	account: Account,
	entitlements: EntitlementsContextApi
) => {
	return (
		canEditTemplate(documentTemplate) &&
		isCreateTemplateActionAvailable(account, entitlements) &&
		(!documentTemplate.templateType || documentTemplate.templateType === 'Static')
	);
};

export const canShareTemplate = (documentTemplate: DocumentTemplate) => {
	return !!documentTemplate?.permissions?.canShare;
};

export const isCreateEditableWordTemplateActionAvailable = (
	entitlements: EntitlementsContextApi
) => {
	return (
		entitlements.getEntitlementStatus(Entitlements.CreateEditableTemplate) &&
		getFeatureFlagValue(FeatureFlag.CreateEditableWordTemplate)
	);
};
